import { render } from "./ArgonInput.vue?vue&type=template&id=cb72b002"
import script from "./ArgonInput.vue?vue&type=script&lang=js"
export * from "./ArgonInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/JBN/mi-stock-jbn-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__